import { IAppState } from '~/shared/store/types'

import { getPurchaseCommonEventParams } from './getPurchaseCommonEventParams'

export const getPurchaseFailedEventParams = (state: IAppState) => {
  const {
    email,
    productId,
    price,
    trialPriceId,
    trialPeriodDays,
    currency,
    screenName,
    stripeAccountName,
    stripeAccountId,
  } = getPurchaseCommonEventParams(state)

  return {
    email,
    productId,
    priceDetails: {
      price,
      trial: !!trialPriceId,
      currency,
    },
    isTrialActive: !!trialPeriodDays,
    screenName,
    stripeAccountName,
    stripeAccountId,
  }
}
